// src/helpers/date.ts

/**
 * Formats a Date or date string to 'dd.mm.yyyy'.
 * @param date Date object or string parseable by Date
 * @returns string in 'dd.mm.yyyy' format
 */
export function formatDateUtil(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}
